module.exports = __webpack_public_path__ + "img/P28920580Dling.36efe830.jpg";